import 'styles/components/selectable-buttons.scss'
import { range } from 'lodash'
import PropTypes from 'prop-types'
import React from 'react'
import Button from 'components/button'

const SelectableButtons = ({ ltr, min, name, selected, step, onClick, rtl }) => {
  const direction =
    ltr === null && rtl === null ? null : (
      <div className="selectable-buttons-direction">
        {ltr === null ? null : <div className="ltr">&larr;{ltr}</div>}
        {rtl === null ? null : <div className="rtl">{rtl}&rarr;</div>}
      </div>
    )

  return (
    <div className="selectable-buttons">
      <div className="selectable-buttons-in">
        {range(min, min + step).map(value => (
          <Button
            key={name === null ? value : `${name}_${value}`}
            className="btn"
            isSelected={selected === value}
            onClick={() => onClick(value)}
          >
            {value}
          </Button>
        ))}
      </div>
      {direction}
    </div>
  )
}

SelectableButtons.propTypes = {
  ltr: PropTypes.string,
  min: PropTypes.number,
  name: PropTypes.string,
  selected: PropTypes.number,
  step: PropTypes.number,
  rtl: PropTypes.string,
  onClick: PropTypes.func.isRequired
}

SelectableButtons.defaultProps = {
  ltr: null,
  name: null,
  min: 1,
  selected: null,
  step: 5,
  rtl: null
}

export default SelectableButtons
